module.exports = __webpack_public_path__ + "img/austal-logo.3c0cd72b.jpg";